import {useCallback} from 'react'

import {MemexColumnDataType} from '../../api/columns/contracts/memex-column'
import type {ParentIssue} from '../../api/common-contracts'
import type {SidePanelItem} from '../../api/memex-items/side-panel-item'
import {useUpdateItem} from '../use-update-item'

type UseTypeEditorProps = {
  model: SidePanelItem
  onSaved?: () => void
}

export function useParentIssueEditor({model, onSaved}: UseTypeEditorProps) {
  const {updateItem} = useUpdateItem()

  const saveSelected = useCallback(
    async (parentIssue: ParentIssue | undefined) => {
      await updateItem(model, {
        dataType: MemexColumnDataType.ParentIssue,
        value: parentIssue,
      })
      onSaved?.()
    },
    [model, onSaved, updateItem],
  )

  return {
    saveSelected,
  }
}
